"use strict";
// Paycheck type definitions (#384) — the next paycheck + per-pay-period history.
//
// UI-facing camelCase shapes shared by web (Vite) and mobile (Expo). The web API
// layer (frontend/src/api/paycheck.ts) mirrors the backend's snake_case response
// and adapts it onto these types. Monetary values are JS numbers here.
//
// Honesty note: Plaid provides only the NET deposit, never a payroll
// gross/tax/deduction breakdown. `netAmount` is the deposit; per-period
// `remainder = income − expenses` (debt payments are already part of expenses,
// never subtracted twice). Since BEN-141 P31 there IS a gross figure, and the
// note is what constrains it: it is null until the user tells us what their pay
// stub says, and nothing derives it from the deposit.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=paycheck.js.map